<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <div class="card">
      <div class="card-body">
        <h3 class="p-2">
          กระเป๋าเงินสมาชิก
        </h3>
        <div>
          <h2 class="text-dark font-medium-3">
            <i class="fa fa-search" /> ค้นหา
          </h2>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div
              class="form-group"
            >
              <label for="username">รหัสสมาชิก</label>
              <input
                v-model="search_userID"
                type="text"
                class="form-control"
                placeholder="รหัสสมาชิก"
              >
            </div>
          </div>
          <div class="col-md-3">
            <div
              class="form-group"
            >
              <label for="username">กระเป๋าเงิน</label>
              <input
                v-model="search_Wallet"
                type="number"
                class="form-control"
                placeholder="ยอดเงิน"
              >
            </div>
          </div>
          <div class="col-md-12">
            <button
              class="btn btn-gradient-dark"
              @click="GetWallet()"
            >
              <feather-icon icon="SearchIcon" /> ค้นหา
            </button>
          </div>
        </div>

      </div>
    </div>
    <b-card
      no-body
    >
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <div
            style="display: flex"
          >
            <b-button
              v-b-modal.modal-1
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-primary"
              class="mr-1"
              @click="exportToExcel()"
            >
              โหลดไฟล์ Excel
            </b-button>
            <!-- <b-button
              v-b-modal.modal-2
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-danger"
              @click="search = false, tel = null , member = null"
            >
              โหลดไฟล์ PDF
            </b-button> -->
          </div>
        </div>
      </b-card-body>
      <b-table
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #cell(userID)="data">
          {{ data.item.username }}
        </template>
        <template #cell(wallet)="data">
          {{ Commas(data.item.balance) }}
        </template>
        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="GetWallet()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="GetWallet()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>

  </b-overlay>
</template>

<script>
// import moment from 'moment-timezone'
import {
  VBTooltip,
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BButton,
  BCardBody,
  VBToggle,
  BOverlay,
  BIconController,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    // flatPickr,
    // BRow,
    // BCol,
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BCardBody,
    BOverlay,
    BIconController,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20, 100, 500, 1000],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      NumberItem: [
        { value: 1, text: 100 },
        { value: 7, text: 500 },
        { value: 2, text: 1000 },
        { value: 3, text: 1500 },
        { value: 4, text: 2000 },
      ],

      fields: [
        { key: 'index', label: 'No.' },
        { key: 'userID', label: 'รหัสสมาชิก' },
        { key: 'wallet', label: 'กระเป๋าเงิน' },
      ],

      items: [
        // {
        //   index: 1, userID: '0999999999', wallet: 50000,
        // },
      ],
      search_userID: null,
      search_Wallet: 0,
      show: false,
    }
  },
  mounted() {
    this.GetWallet()
  },
  methods: {
    GetWallet() {
      this.show = true
      const params = {
        perPage: this.perPage,
        page: this.currentPage,
        search_userID: this.search_userID,
        search_Wallet: this.search_Wallet,
      }
      this.$http.get('/admin/SearchWalletbalance', { params })
        .then(response => {
          this.items = response.data.data
          this.totalRows = response.data.total
          this.show = false
        }).catch(err => {
          console.log(err)
          this.show = false
        })
    },
    exportToExcel() {
      this.show = true
      const params = {
        perPage: this.perPage,
        page: this.currentPage,
        search_userID: this.search_userID,
        search_Wallet: this.search_Wallet,
      }
      this.$http.get('/admin/export', { params })
        .then(response => {
          // console.log(response.data)
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'กระเป๋าเงินสมาชิก.xls' // ระบุชื่อไฟล์ที่ต้องการบันทึก
          link.click()
          this.show = false
        }).catch(err => {
          console.log(err)
          this.show = false
        })
    },
    Commas(x) {
      if (Math.round(x) !== x && x > 0) {
        const Num = Number(x)
        const y = Num.toFixed(2)
        return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
